import React from 'react';
import PropTypes from 'prop-types';
import AccessibleTooltip from '../../common/AccessibleTooltip';
import difficultyTooltipText from '../../../data/testlet/difficultyLevelTooltipText';

// what a read-only difficulty value needs to show its tooltip on focus and to carry it as its description
export const difficultyTargetProps = (id, difficultyLevel) =>
  difficultyTooltipText[difficultyLevel] ? { tabIndex: 0, 'aria-describedby': id + '-description' } : {};

const DifficultyLevelToolTip = ({ id, difficultyLevel }) => {
  const text = difficultyTooltipText[difficultyLevel];

  if (!text) {
    return null;
  }

  return (
    <>
      <span id={id + '-description'} hidden>
        {text}
      </span>
      <AccessibleTooltip placement="left" target={id}>
        {text}
      </AccessibleTooltip>
    </>
  );
};

DifficultyLevelToolTip.propTypes = {
  id: PropTypes.string,
  difficultyLevel: PropTypes.string
};

export default DifficultyLevelToolTip;
